import {Component, OnDestroy, OnInit} from '@angular/core';
import {FeatureSet} from "../../core/statistics-page-menu/statistics-page-menu.component";
import {environment} from "../../../environments/environment";
import {ItemKpiService} from "../services/item-kpi.service";
import {map} from "rxjs/operators";
import {Subscription} from "rxjs";
import {ChartPeriod} from "../../core/timeline-selection/timeline-selection.component";
import {ProductKpiService} from "../services/product-kpi.service";
import {StatisticsService} from '../services/statistics.service';
import {ProductType} from '../../core/models/product-type.model';
import {ExportsService} from '../../core/services/exports.service';
import {UnauthorizedCabinetAccessService} from '../services/unauthorized-cabinet-access.service'
import { of } from 'rxjs';

@Component({
  selector: 'cintas-customer-summary-view',
  templateUrl: './customer-summary-view.component.html',
  styleUrls: ['./customer-summary-view.component.scss']
})
export class CustomerSummaryViewComponent implements OnInit, OnDestroy {

  selectedCustomer;

  timeSelection: ChartPeriod = ChartPeriod.THIS_YEAR;
  timeSelectionAtSite: ChartPeriod = ChartPeriod.THIS_YEAR;
  timeSelectionIncomingOutgoing: ChartPeriod = ChartPeriod.THIS_YEAR;
  productTypeIncomingOutgoing: ProductType;

  summaryDate = Date();

  features: FeatureSet = {
    // export: true,
    timeline: false,
    customers: true
  };

  view = environment.theme.baseView;
  viewLimit = [200, 100];
  colorScheme = environment.theme.colorPalette;

  // options
  showLegend = false;

  // pie
  showLabels = true;
  explodeSlices = false;
  doughnut = false;

  private noItemPerProduct$;
  private noItemsPerProductSub: Subscription;
  noItemsPerProduct: any[];
  unauthorizedAccessData: any[] = [];

  noLostItems$;

  avgTurnaroundTime$;

  itemsAtSiteOverTimeData$;
  exportItemsAtLocationLoading;

  incomingOutgoingOverTimeData$;
  exportItemsDeliveredReturnedLoading;


  constructor(private itemKpiService: ItemKpiService, private productKpiService: ProductKpiService,
              private statServices: StatisticsService, private exportService: ExportsService, private unauthorizedCabinetAccessService: UnauthorizedCabinetAccessService) {
  }

  ngOnInit() {
    this.avgTurnaroundTime$ = of([
      { name: 'Sweat Jacket XL', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -28 },
      { name: 'Sweat Jacket L', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 },
      { name: 'Sweat Jacket M', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 },
      { name: 'Sweat Jacket S', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 },
      { name: 'Poloshirt XL', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 },
      { name: 'Poloshirt L', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 },
      { name: 'Poloshirt M', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 },
      { name: 'Poloshirt S', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: -20 }
    ]);
  }

  

  ngOnDestroy(): void {
    if (this.noItemsPerProductSub) {
      this.noItemsPerProductSub.unsubscribe();
    }
  }

  onCustomerSelected(customer) {
    this.selectedCustomer = customer;
    this.noItemPerProduct$ = this.itemKpiService.getNoItemsPerCustomer(customer.cuid);
    this.noItemsPerProductSub = this.noItemPerProduct$.subscribe(res => {
      if (res.data && res.data.length > 0) {
        this.noItemsPerProduct = res.data[0].series;
      } else {
        this.noItemsPerProduct = []; 
      }
    });

    this.noLostItems$ = this.itemKpiService.getNoOfLostItemsForLocation(this.selectedCustomer.__typename, this.selectedCustomer.cuid).pipe(map((res: any) => res.data));

    this.unauthorizedCabinetAccessService.getUnauthorizedCabinetAccessSummary(this.selectedCustomer.cuid)
    .pipe(map((res: any) => res.data))
    .subscribe(
      data => {
        console.log(data)
        this.unauthorizedAccessData = data; 
      },
    );
    this.onPeriodChanged(this.timeSelection);
    this.onPeriodNoItemsChanged(this.timeSelectionAtSite);
    this.onPeriodIncomingOutgoindOverTimeChanged(this.timeSelectionAtSite);
  }


onPeriodChanged(period) {
  this.timeSelection = period;
  console.log(period);

  const mockData = {
      "Now": [
        { name: 'Sweat Jacket XL', value: 5.2 },
        { name: 'Sweat Jacket L', value: 4.5 },
        { name: 'Sweat Jacket M', value: 6.0 },
        { name: 'Sweat Jacket S', value: 5.1 },
        { name: 'Poloshirt XL', value: 3.0 },
        { name: 'Poloshirt L', value: 8.0 },
        { name: 'Poloshirt M', value: 11.0 },
        { name: 'Poloshirt S', value: 9.2 }
      ],
      "This week": [
        { name: 'Sweat Jacket XL', value: 4.8 },
        { name: 'Sweat Jacket L', value: 5.0 },
        { name: 'Sweat Jacket M', value: 6.5 },
        { name: 'Sweat Jacket S', value: 5.3 },
        { name: 'Poloshirt XL', value: 3.5 },
        { name: 'Poloshirt L', value: 7.2 },
        { name: 'Poloshirt M', value: 12.1 },
        { name: 'Poloshirt S', value: 8.8 }
      ],
      "This month": [
        { name: 'Sweat Jacket XL', value: 6.0 },
        { name: 'Sweat Jacket L', value: 4.0 },
        { name: 'Sweat Jacket M', value: 5.8 },
        { name: 'Sweat Jacket S', value: 5.7 },
        { name: 'Poloshirt XL', value: 2.8 },
        { name: 'Poloshirt L', value: 8.5 },
        { name: 'Poloshirt M', value: 11.2 },
        { name: 'Poloshirt S', value: 10.1 }
      ],
      "Last month": [
        { name: 'Sweat Jacket XL', value: 5.1 },
        { name: 'Sweat Jacket L', value: 4.2 },
        { name: 'Sweat Jacket M', value: 6.3 },
        { name: 'Sweat Jacket S', value: 5.4 },
        { name: 'Poloshirt XL', value: 3.1 },
        { name: 'Poloshirt L', value: 7.9 },
        { name: 'Poloshirt M', value: 12.8 },
        { name: 'Poloshirt S', value: 9.0 }
      ],
      "This year": [
        { name: 'Sweat Jacket XL', value: 7.0 },
        { name: 'Sweat Jacket L', value: 5.3 },
        { name: 'Sweat Jacket M', value: 6.7 },
        { name: 'Sweat Jacket S', value: 5.6 },
        { name: 'Poloshirt XL', value: 2.5 },
        { name: 'Poloshirt L', value: 8.2 },
        { name: 'Poloshirt M', value: 10.0 },
        { name: 'Poloshirt S', value: 10.5 }
      ],
      "Last year": [
        { name: 'Sweat Jacket XL', value: 5.6 },
        { name: 'Sweat Jacket L', value: 4.9 },
        { name: 'Sweat Jacket M', value: 6.4 },
        { name: 'Sweat Jacket S', value: 5.8 },
        { name: 'Poloshirt XL', value: 3.3 },
        { name: 'Poloshirt L', value: 8.7 },
        { name: 'Poloshirt M', value: 12.0 },
        { name: 'Poloshirt S', value: 9.4 }
      ],
      "Since 1 week": [
        { name: 'Sweat Jacket XL', value: 4.4 },
        { name: 'Sweat Jacket L', value: 5.4 },
        { name: 'Sweat Jacket M', value: 6.1 },
        { name: 'Sweat Jacket S', value: 5.9 },
        { name: 'Poloshirt XL', value: 2.7 },
        { name: 'Poloshirt L', value: 7.4 },
        { name: 'Poloshirt M', value: 11.6 },
        { name: 'Poloshirt S', value: 8.9 }
      ],
      "Since 2 week": [
        { name: 'Sweat Jacket XL', value: 5.0 },
        { name: 'Sweat Jacket L', value: 4.3 },
        { name: 'Sweat Jacket M', value: 6.2 },
        { name: 'Sweat Jacket S', value: 5.0 },
        { name: 'Poloshirt XL', value: 3.8 },
        { name: 'Poloshirt L', value: 7.1 },
        { name: 'Poloshirt M', value: 11.4 },
        { name: 'Poloshirt S', value: 9.5 }
      ],
      "Since 1 month": [
        { name: 'Sweat Jacket XL', value: 5.3 },
        { name: 'Sweat Jacket L', value: 4.6 },
        { name: 'Sweat Jacket M', value: 5.9 },
        { name: 'Sweat Jacket S', value: 5.2 },
        { name: 'Poloshirt XL', value: 2.9 },
        { name: 'Poloshirt L', value: 8.0 },
        { name: 'Poloshirt M', value: 12.3 },
        { name: 'Poloshirt S', value: 10.2 }
      ],
      "Since 3 month": [
        { name: 'Sweat Jacket XL', value: 6.5 },
        { name: 'Sweat Jacket L', value: 5.1 },
        { name: 'Sweat Jacket M', value: 6.0 },
        { name: 'Sweat Jacket S', value: 5.3 },
        { name: 'Poloshirt XL', value: 3.4 },
        { name: 'Poloshirt L', value: 7.7 },
        { name: 'Poloshirt M', value: 11.8 },
        { name: 'Poloshirt S', value: 9.1 }
      ],
      "Since 1 year": [
        { name: 'Sweat Jacket XL', value: 5.9 },
        { name: 'Sweat Jacket L', value: 4.7 },
        { name: 'Sweat Jacket M', value: 6.9 },
        { name: 'Sweat Jacket S', value: 5.8 },
        { name: 'Poloshirt XL', value: 3.6 },
        { name: 'Poloshirt L', value: 8.4 },
        { name: 'Poloshirt M', value: 12.6 },
        { name: 'Poloshirt S', value: 9.8 }
      ]
    




  

    // "5": [
    //   { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
    //   { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
    // ]
    // ,

    // "6": [
    //   { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
    //   { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
    // ]
  };

  const data = mockData[period] || [];
  this.avgTurnaroundTime$ = of(data)
  this.avgTurnaroundTime$.subscribe(
    data => {
      console.log(data)
      this.unauthorizedAccessData = data; 
    },
  );
  console.log(this.avgTurnaroundTime$)
  return of({ data });
  // Replace with appropriate hardcoded data based on the period selection
  // console.log(period);
  // if(period === "This year"){

  // }
  // this.avgTurnaroundTime$ = of([
  //   { name: 'Sweat Jacket XL', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 5.2 },
  //     { name: 'Sweat Jacket L', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 4.8 },
  //     { name: 'Sweat Jacket M', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 6.2 },
  //     { name: 'Sweat Jacket S', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 5.5 },
  //     { name: 'Poloshirt XL', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 3.2 },
  //     { name: 'Poloshirt L', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 7.8 },
  //     { name: 'Poloshirt M', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 12.5 },
  //     { name: 'Poloshirt S', no_items_in_group: 100, expected_lifetime: 500, avg_cycle_count: 480, value: 9.6 }
  // ]);
}

  // onPeriodChanged(period: ChartPeriod) {
  //   this.timeSelection = period;
  //   this.avgTurnaroundTime$ = this.productKpiService.getAvgTurnaroundTimePerProductType(this.timeSelection, null , null , this.selectedCustomer.cuid).pipe(
  //     map((res: any) => {
  //       let data: any[] = res.data;
  //       return data;
  //     })
  //   );
  // }

  onPeriodNoItemsChanged(period: ChartPeriod) {
    this.timeSelectionAtSite = period;
    this.itemsAtSiteOverTimeData$ = this.itemKpiService.getNoItemsOverTime(this.selectedCustomer.__typename, this.selectedCustomer.cuid, this.timeSelectionAtSite).pipe(
      map((res: any) => {
        return JSON.parse(JSON.stringify(res), this.statServices.reviver).data;
      }));
  }

  onPeriodIncomingOutgoindOverTimeChanged(period: ChartPeriod) {
    this.timeSelectionIncomingOutgoing = period;
    map((res: any) => {
      // return JSON.parse(JSON.stringify(res), this.statServices.reviver).data;
      return res.data;
    });
  }

  onTypeChange(t: ProductType) {
    this.productTypeIncomingOutgoing = t;
    this.incomingOutgoingOverTimeData$ = this.itemKpiService.getIncomingOutgoingItemsOverTime(this.selectedCustomer.__typename, this.selectedCustomer.cuid, this.productTypeIncomingOutgoing.cuid, this.timeSelectionIncomingOutgoing).pipe(
      map((res: any) => {
        return res.data;
      }));
  }

  onExportItemsAtLocation() {
    this.exportItemsAtLocationLoading = true;
    this.exportService.exportItemsAtLocationData(this.selectedCustomer.__typename, this.selectedCustomer.cuid, this.timeSelectionAtSite)
      .subscribe(response => {
        this.exportItemsAtLocationLoading = false;
        this.exportService.saveToFileSystem(response);
      }, err => {
        this.exportItemsAtLocationLoading = false;
      });
  }

  onExportIncomingOutgoingItems() {
    this.exportItemsDeliveredReturnedLoading = true;
    this.exportService.exportIncomingOutgoingProductsOverTimeData(this.selectedCustomer.__typename, this.selectedCustomer.cuid, this.productTypeIncomingOutgoing.cuid, this.timeSelectionIncomingOutgoing)
      .subscribe(response => {
        this.exportItemsDeliveredReturnedLoading = false;
        this.exportService.saveToFileSystem(response);
      }, err => {
        this.exportItemsDeliveredReturnedLoading = false;
      });
  }

  changeView(view) {
    this.viewLimit = view;
  }

}
